import { render, staticRenderFns } from "./TableDisplayColumn.vue?vue&type=template&id=13d205c6"
import script from "./TableDisplayColumn.vue?vue&type=script&lang=js"
export * from "./TableDisplayColumn.vue?vue&type=script&lang=js"
import style0 from "./TableDisplayColumn.vue?vue&type=style&index=0&id=13d205c6&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/.jenkins/workspace/overseas_platform_prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13d205c6')) {
      api.createRecord('13d205c6', component.options)
    } else {
      api.reload('13d205c6', component.options)
    }
    module.hot.accept("./TableDisplayColumn.vue?vue&type=template&id=13d205c6", function () {
      api.rerender('13d205c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CommonTable/TableDisplayColumn.vue"
export default component.exports